import { render, staticRenderFns } from "./EditDriverDetails.vue?vue&type=template&id=20fc403a&scoped=true"
import script from "./EditDriverDetails.vue?vue&type=script&lang=js"
export * from "./EditDriverDetails.vue?vue&type=script&lang=js"
import style0 from "./EditDriverDetails.vue?vue&type=style&index=0&id=20fc403a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc403a",
  null
  
)

export default component.exports